// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"PostbackTemplatesTab-primaryButton-3DWg4h","infoList":"PostbackTemplatesTab-infoList-3Gg4sv"};